<template>
  <div class="row reverse-mobile justify-content-center">
    <TmsMenu />
    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="overflow-hidden">
        <LoadingSpinner v-if="isLoading" />
        <router-view v-else></router-view>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import CommunityCard from "@/components/CommunityCard";
import TmsMenu from "@/components/Tms/TmsMenu";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "Tms",
  components: {
    LoadingSpinner,
    TmsMenu,
    CommunityCard,
  },
  computed: {
    isLoading() {
      return this.$store.state.tmsStore.isLoading;
    },
  },
  beforeMount() {
    this.$store.dispatch("tmsStore/loadDebriefsForCurrentUser");
  },
};
</script>

<style scoped></style>
